import { useRef } from "react";
import { useTranslation } from "react-i18next";

// Saisie du code oral 9 chiffres : 3 blocs [XXX][XXX][XXX], auto-avance, retour arrière, collage.
export const OralCodeInput = ({ value, onChange, disabled, onComplete }) => {
  const { t } = useTranslation("sms");
  const refs = [useRef(null), useRef(null), useRef(null)];
  const blocks = [value.slice(0, 3), value.slice(3, 6), value.slice(6, 9)];

  const setAll = (digits) => {
    const v = digits.replace(/\D/g, "").slice(0, 9);
    onChange(v);
    const idx = Math.min(Math.floor(v.length / 3), 2);
    refs[idx].current?.focus();
    if (v.length === 9) onComplete?.(v);
  };

  const onBlockChange = (i, raw) => {
    const digits = raw.replace(/\D/g, "");
    if (digits.length > 3) { setAll(blocks.slice(0, i).join("") + digits); return; }
    const next = [...blocks];
    next[i] = digits;
    const v = next.join("").slice(0, 9);
    onChange(v);
    if (digits.length === 3 && i < 2) refs[i + 1].current?.focus();
    if (v.length === 9) onComplete?.(v);
  };

  const onKeyDown = (i, e) => {
    if (e.key === "Backspace" && !blocks[i] && i > 0) {
      e.preventDefault();
      const prev = blocks[i - 1];
      const next = [...blocks];
      next[i - 1] = prev.slice(0, -1);
      onChange(next.join(""));
      refs[i - 1].current?.focus();
    }
  };

  const onPaste = (e) => {
    const text = e.clipboardData.getData("text") || "";
    if (!/\d/.test(text)) return;
    e.preventDefault();
    setAll(text);
  };

  return (
    <div className="flex items-center justify-center gap-2 sm:gap-3" data-testid="oral-code-input">
      {blocks.map((b, i) => (
        <input
          key={i}
          ref={refs[i]}
          data-testid={`oral-code-block-${i}`}
          aria-label={t("recipient.digitsAria", { from: i * 3 + 1, to: i * 3 + 3 })}
          value={b}
          disabled={disabled}
          onChange={(e) => onBlockChange(i, e.target.value)}
          onKeyDown={(e) => onKeyDown(i, e)}
          onPaste={onPaste}
          onFocus={(e) => e.target.select()}
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="off"
          autoCorrect="off"
          spellCheck={false}
          placeholder="•••"
          className="ph-no-capture w-[5.5rem] sm:w-24 h-16 rounded-xl bg-slate-800/70 border-2 border-slate-700 text-white text-center text-3xl font-mono-token tracking-[0.2em] tabular-nums outline-none placeholder:text-slate-600 focus:border-emerald-500 focus:bg-slate-800 transition-colors disabled:opacity-50"
        />
      ))}
    </div>
  );
};
